<template>
  <div class="CourseVideoSeting">
    <a-card class="card" :bordered="false">
      <BaseSet></BaseSet>
    </a-card>
  </div>
</template>

<script>
import BaseSet from "./components/BaseSet";
import $Bus from "@/pages/projectImpl/js/eventBus";
export default {
  name: "CourseVideoSeting",
  components: { BaseSet },
  data() {
    return {};
  },
    mounted() {
        let tabName = "课程视频配置";
        const info = this.$store.getters["content/getCourseVideoInfo"]();
        if (this.$route.query.type == "edit"&&info.contentName) {
            tabName = `${info.contentName}${info.versionName ? ' - ' + info.versionName : ''} 配置`;
        }
        const arr = ["首页", "内容中心", {name: "课程视频", path: info.fullPath || "/content/CourseVideo"}, "课程视频配置"];
        $Bus.$emit("pageHeaderTitle", tabName);
        $Bus.$emit("pageHeaderBreadcrumb", arr);
        $Bus.$emit("updateTabName", {path: this.$route.path, name: tabName});
    },
  beforeDestroy() {
        $Bus.$emit("pageHeaderTitle", false);
  },
  methods: {

  }
};
</script>

<style scoped lang="less">
.CourseVideoSeting {
  width: 100%;
  height: 100%;
}
</style>
